
export const pricing = [
    {
        name:"Starter",
        ppm:"165",
        amp: "1,800",
        content:
        [
            "List up to 25 listings",
            "Access to property manager",
            "Access to Local Enquires"
        ],
        notIncludes: [
            "Additional data management",
            "Access to all property and scheme data",
            "3rd party integration"
        ],
        buttonText:'Get started',
        popular:false
    },
    {
        name:"Basic",
        ppm:"230",
        amp: "2,500",
        content:
        [
            "List up to 50 listings",
            "Access to property manager",
            "Access to Local Enquires",
            "Additional data management"
        ],
        notIncludes: [
            "Access to all property and scheme data",
            "3rd party integration"
        ],
        buttonText:'Get started',
        popular:false
    },
    {
        name:"Standard",
        ppm:"413",
        amp: "4,500",
        content:
        [
            "List up to 100 listings",
            "Access to property manager",
            "Access to Local Enquires",
            "Additional data management",
            "Access to all property and scheme data",
        ],
        notIncludes: [
            "3rd party integration"
        ],
        buttonText:'Get started',
        popular:true
    },
    {
        name:"Premium",
        ppm:"730",
        amp: "8,000",
        content:
        [
            "List up to 200 listings",
            "Access to property manager",
            "Access to Local Enquires",
            "Additional data management",
            "Access to all property and scheme data",
            "3rd party integration"
        ],
        notIncludes: [
        ],
        buttonText:'Get started',
        popular:false
    }
]

export const reviews = [
    {
        author: 'Ian Whelan',
        reviewerDetail: 'Managing Partner',
        description: '“We’ve worked with Completely Retail for over 15 years and what sets them apart is not just their exceptional property listing platform, but the people behind it. Their team genuinely understand the retail and leisure market and have provided EYCO with unparalleled support and guidance from the outset"',
        logo: 'sales/eyco.png',
        company: 'eyco'
    },
    {
        author: 'David Bannister',
        reviewerDetail: 'Executive Director',
        description: "“Our listings have been powered by Completely Retail for over 5 years, they rank highly for London and allow our properties to reach a much wider audience. The team is professional, approachable and always ready to help. I’d recommend Completely Retail to anyone looking for a reliable platform to market their retail and leisure properties.”",
        logo: 'sales/nashbound.png',
        company: 'nashbound'
    },
];